import { __read } from "tslib";
import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { SelectionBarMarginTopDefault, SelectionBarMarginTopWide, } from './Constants';
import { useSelectionBarStyles } from './TileSelectionBar.styles';
/**
 * Tile Selection Bar React functional component.
 *
 */
export var TileSelectionBarRender = function (_a, ref) {
    var id = _a.id, animate = _a.animate, wide = _a.wide, color = _a.color, anchored = _a.anchored, initialVisibility = _a.initialVisibility;
    var barRef = React.useRef(null);
    var _b = __read(React.useState(color), 2), barColor = _b[0], setBarColor = _b[1];
    var _c = __read(React.useState(0), 2), position = _c[0], setBarPosition = _c[1];
    var _d = __read(React.useState(initialVisibility), 2), visible = _d[0], setVisible = _d[1];
    var styles = useSelectionBarStyles();
    var barStyles = React.useMemo(function () {
        return mergeClasses(styles.root, styles.defaultColor, animate && styles.animated, wide && styles.wide, anchored && styles.anchored);
    }, [
        anchored,
        animate,
        styles.anchored,
        styles.animated,
        styles.defaultColor,
        styles.root,
        styles.wide,
        wide,
    ]);
    /**
     Effect to update selection bar color
     */
    React.useEffect(function () {
        if (!barRef.current) {
            return;
        }
        barRef.current.style.backgroundColor = barColor || '';
    }, [barColor]);
    /**
     * Effect to update selection bar visibility
     */
    React.useEffect(function () {
        if (!barRef.current) {
            return;
        }
        barRef.current.style.visibility = visible ? 'visible' : 'hidden';
    }, [visible]);
    /**
     * Effect to update selection bar position
     */
    React.useLayoutEffect(function () {
        if (anchored || !barRef.current) {
            return;
        }
        var prevTop = barRef.current.offsetTop;
        var newTop = position;
        var selectionBarMarginTop = wide
            ? SelectionBarMarginTopWide
            : SelectionBarMarginTopDefault;
        barRef.current.style.transform = "translate(0px, ".concat(selectionBarMarginTop + (newTop - prevTop), "px)");
    }, [anchored, position, wide]);
    React.useImperativeHandle(ref, function () { return ({
        setColor: setBarColor,
        setPosition: setBarPosition,
        setVisible: setVisible,
    }); }, []);
    return React.createElement("div", { id: id, ref: barRef, className: barStyles });
};
TileSelectionBarRender.displayName = 'TileSelectionBar';
export var TileSelectionBar = React.forwardRef(TileSelectionBarRender);
//# sourceMappingURL=TileSelectionBar.js.map